import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function FloridaSection() {
  const benefits = [{
    title: 'Bajo costo',
    desc: 'sin impuesto estatal sobre ingresos personales'
  }, {
    title: 'Simplicidad',
    desc: 'proceso claro y directo'
  }, {
    title: 'Flexibilidad',
    desc: 'ideal para negocios locales, remotos e internacionales'
  }, {
    title: 'Inicio rápido',
    desc: 'tiempos de registro accesibles'
  }, {
    title: 'Enfoque en crecimiento',
    desc: 'estructura que te permite escalar'
  }];
  return <section id="florida" className="py-24 bg-inkova-light" data-id="element-140">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-6" data-id="element-143">
            Florida no es solo una&nbsp;opción.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl text-gray-700 font-light" data-id="element-144">
            Para muchos emprendedores latinos, es la{' '}
            <span className="font-medium text-inkova-primary" data-id="element-145">
              opción&nbsp;inteligente.
            </span>
          </motion.p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-inkova-accent/20 mb-12" data-id="element-146">
          <p className="text-lg text-gray-600 mb-8 text-center" data-id="element-147">
            Cuando buscas:
          </p>
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-148">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start" data-id="element-149">
                <CheckCircle2 className="w-6 h-6 text-inkova-accent mr-4 flex-shrink-0 mt-0.5" data-id="element-150" />
                <p className="text-gray-700" data-id="element-151">
                  <strong className="text-inkova-primary" data-id="element-152">
                    {benefit.title}
                  </strong>{' '}
                  — {benefit.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-153">
          <p className="text-2xl md:text-3xl font-serif text-inkova-primary italic mb-8" data-id="element-154">
            Florida te da las condiciones. Inkova te da&nbsp;la&nbsp;dirección.
          </p>
          <div className="bg-white/50 p-6 rounded-2xl border border-inkova-accent/30 inline-block" data-id="element-155">
            <p className="text-gray-700" data-id="element-156">
              ¿Tu caso requiere otro estado? También&nbsp;te&nbsp;orientamos.{' '}
              <br className="hidden md:block" data-id="element-157" />
              Trabajamos con emprendedores latinos en
              todo&nbsp;Estados&nbsp;Unidos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}